import type { ReactNode } from 'react';

import { Icon, type IconName } from '@eliadmin/core/src/components/dlz/ui/icon';
import { cn } from '@eliadmin/core/src/utils/style-utils';

const TONES = {
  success: { box: 'border-[#A9DDB9] bg-[#ECF7EF]', icon: 'text-[#22A04B]' },
  warning: { box: 'border-[#F6D592] bg-[#FEF6E7]', icon: 'text-[#C27A05]' },
} as const;

/**
 * Figma „Price alert“ (60325:21144, mobile 60459:93701): 20 px icon and DLZ/Body/S Medium text in a
 * bordered box – 14 / 20 px padding and radius 12 in the content column, 16 px and radius 18 when
 * the column is phone-wide (`@container` of the favourites view). The warning tone (cart result
 * with skipped products) is the same box in the warning tokens.
 */
export function FavoritesNotice({
  tone = 'success',
  icon,
  action,
  className,
  children,
}: {
  tone?: keyof typeof TONES;
  icon: IconName;
  /** Element at the end of the row (dismiss button). */
  action?: ReactNode;
  className?: string;
  children: ReactNode;
}) {
  return (
    <div
      className={cn(
        'flex items-center gap-3 rounded-[18px] border p-4 @[31rem]:rounded-xl @[31rem]:px-5 @[31rem]:py-3.5',
        TONES[tone].box,
        className,
      )}
    >
      {/* The 24 px drawings at 20 px; 1.8 keeps the 1.5 px Figma stroke. */}
      <Icon
        name={icon}
        size={20}
        className={cn(TONES[tone].icon, '[&_[stroke]]:[stroke-width:1.8]')}
      />
      <div className="dlz-body-s-medium flex min-w-0 flex-1 flex-col gap-1 text-[#0F1012]">
        {children}
      </div>
      {action}
    </div>
  );
}
